<template>
  <div class="dataImport">
    <el-row>
      <!-- 面包屑 -->
      <el-col :span="24">
        <Breadcrumbs :arr="['碳汇管理平台', '会议活动/出行方式']" />
      </el-col>
      <!-- 查询表单 -->
      <el-col class="search" :span="24">
        <el-form :inline="true" :model="search[0]" class="demo-form-inline" v-if="type == 0">
          <el-form-item label="会议名称">
            <el-input size="small" v-model="search[0].meetingName" maxlength="100" clearable placeholder="请输入"
              class="inline-input"></el-input>
          </el-form-item>
          <el-form-item label="交通方式">
            <el-select v-model="search[0].transport" clearable placeholder="请选择" size="small">
              <el-option label="公共交通" :value="0"> </el-option>
              <el-option label="自驾" :value="1"> </el-option>
              <el-option label="飞机" :value="2"> </el-option>
              <el-option label="高铁" :value="3"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="btn">
            <!-- class="theme-btn" -->
            <el-button size="small" type="primary" @click="getList" round>查询</el-button>
            <el-button size="small" style="margin: 0 0 0 50px" @click="reset" round type="info">重置</el-button>
          </el-form-item>
        </el-form>
        <el-form :inline="true" :model="search[1]" class="demo-form-inline" v-else-if="type == 1">
          <el-form-item label="姓名/单位">
            <el-input size="small" v-model="search[1].name" maxlength="100" clearable placeholder="请输入"
              class="inline-input"></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input size="small" v-model="search[1].phone" maxlength="100" clearable placeholder="请输入"
              class="inline-input"></el-input>
          </el-form-item>
          <el-form-item label="交通方式">
            <el-select v-model="search[1].transport" clearable placeholder="请选择" size="small">
              <el-option label="公共交通" :value="0"> </el-option>
              <el-option label="自驾" :value="1"> </el-option>
              <el-option label="飞机" :value="2"> </el-option>
              <el-option label="高铁" :value="3"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="btn">
            <!-- class="theme-btn" -->
            <el-button size="small" type="primary" @click="getList" round>查询</el-button>
            <el-button size="small" style="margin: 0 0 0 50px" @click="reset" round type="info">重置</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <!-- 表格数据 -->
      <el-col class="main_table" :span="24">

        <div class="table_btn">
          <div class="">
            <el-button size="small" :type="type == 0 ? 'primary' : ''" @click="changeTab(0)">会议活动</el-button>
            <el-button size="small" @click="changeTab(1)" :type="type == 1 ? 'primary' : ''">出行方式</el-button>
          </div>
          <div>
            <el-button size="small" type="primary" @click="isExport()">导出</el-button>
          </div>

        </div>
        <div v-if="type == 0">
          <Tables class="table" :columns="table.columns" :loading="table.loading" :tableData="table.tableData">
            <template #transport="scope">
              <div>{{ changeType(scope.row.transport) }}</div>
            </template>
            <template #meetingSize="scope">
              <div>{{ scope.row.meetingSize + 'h' }}</div>
            </template>
            <template #carbonEmission="scope">
              <div>{{ scope.row.carbonEmission + 'kg' }}</div>
            </template>
            <template #trueAmount="scope">
              <div>{{ scope.row.trueAmount + '元' }}</div>
            </template>
            <template #donatedAmount="scope">
              <div>{{ scope.row.donatedAmount ? (scope.row.donatedAmount + '元') : null }}</div>
            </template>
            <template #status="scope">
              <div>{{ scope.row.donatedAmount ? (status[scope.row.status]) : null }}</div>
            </template>
            <template #actions="scope">
              <div class="flex" v-if="scope.row.donatedAmount">
                <!-- <span class="theme-color">修改</span>
                                      <span class="theme-color">删除</span>
                                      <span class="theme-color">详情</span> -->
                <!-- <el-button :style="{ visibility: userInfo.isFirstlevel ? 'visible' : 'hidden' }"
                  :type="scope.row.status != 0 ? 'info' : 'primary'" @click="checkOne(scope.row.id)"
                  :class="scope.row.status == 0 ? 'check-item' : 'uncheck-item'"
                  :disabled="scope.row.status != 0">一级审核</el-button> -->
                <el-button :style="{ visibility: userInfo.isTwolevel ? 'visible' : 'hidden' }"
                  :type="scope.row.status != 1 ? 'info' : 'primary'" @click="checkTwo(scope.row.id)"
                  :class="scope.row.status == 1 ? 'check-item' : 'uncheck-item'"
                  :disabled="scope.row.status != 1">审核</el-button>
              </div>
            </template>
          </Tables>
          <Paginations :pageData="table.pageData" :sizeChange="sizeChange" :currentChange="currentChange" />
        </div>
        <div v-if="type == 1">
          <Tables class="table" :columns="table1.columns" :loading="table1.loading" :tableData="table1.tableData">
            <template #transport="scope">
              <div>{{ changeType(scope.row.transport) }}</div>
            </template>
            <template #carbonEmission="scope">
              <div>{{ scope.row.carbonEmission + 'kg' }}</div>
            </template>
            <template #trueAmount="scope">
              <div>{{ scope.row.trueAmount + '元' }}</div>
            </template>
            <template #donatedAmount="scope">
              <div>{{ scope.row.donatedAmount ? (scope.row.donatedAmount + '元') : null }}</div>
            </template>
            <template #status="scope">
              <div>{{ scope.row.donatedAmount ? (status[scope.row.status]) : null }}</div>
            </template>
            <template #actions="scope">
              <div class="flex" v-if="scope.row.donatedAmount">
                <!-- <span class="theme-color">修改</span>
                                    <span class="theme-color">删除</span>
                                    <span class="theme-color">详情</span> -->
                <!-- <el-button :style="{ visibility: userInfo.isFirstlevel ? 'visible' : 'hidden' }"
                  :type="scope.row.status != 0 ? 'info' : 'primary'" @click="checkOne(scope.row.id)"
                  :class="scope.row.status == 0 ? 'check-item' : 'uncheck-item'"
                  :disabled="scope.row.status != 0">一级审核</el-button> -->
                <el-button :style="{ visibility: userInfo.isTwolevel ? 'visible' : 'hidden' }"
                  :type="scope.row.status != 0 ? 'info' : 'primary'" @click="checkTwo(scope.row.id)"
                  :class="scope.row.status == 0? 'check-item' : 'uncheck-item'"
                  :disabled="scope.row.status != 0">审核</el-button>

              </div>
            </template>
          </Tables>
          <Paginations :pageData="table1.pageData" :sizeChange="sizeChange" :currentChange="currentChange" />
        </div>
      </el-col>
    </el-row>
    <el-dialog title="导出" :visible.sync="dialogVisible" width="40%" :before-close="handleClose">
      <el-form ref="form" :inline="true" :model="form" :rules="rules" label-width="100px" size="small">
        <el-form-item id="time" label="选择日期" prop="startDate" class="inlinitem">
          <el-date-picker v-model="form.startDate" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
            style="width: 200px" placeholder="开始日期" :picker-options="pickerOptions3">
          </el-date-picker>
        </el-form-item>
        <el-form-item class="inlinitem" prop="endDate">
          <el-date-picker v-model="form.endDate" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
            style="width: 200px" :picker-options="pickerOptions4" placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
      </el-form>


      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitExport">提交</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
import {
  getActivity,
  handleCheckOne,
  handleCheckTwo,
  activityExport,
  travelExport
} from "@/api/api";
import Breadcrumbs from "@/components/breadcrumbs/breadcrumbs.vue"
import Tables from "@/components/tables/tables.vue"
import Paginations from "@/components/paginations/paginations.vue"
import { columns, columns1 } from "./js/columns"
export default {
  name: "dataImport",
  data() {
    return {
      status: {
        0: '待审核',
        1: '审核中',
        2: '已完成'
      },
      search: [{
        "meetingName": "",
        "transport": "",
        "type": ""
      }, {
        "name": "",
        "phone": "",
        "transport": "",
        "type": ""
      }],
      //日期选择范围在一个月内
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.selectDate = minDate.getTime();
          if (maxDate) {
            this.selectDate = "";
          }
        },
        disabledDate: (time) => {
          if (this.selectDate !== "") {
            const one = 30 * 24 * 3600 * 1000;
            const minTime = this.selectDate - one;
            const maxTime = this.selectDate + one;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
        },
      },
      // 零碳活动
      table: {
        // 表格展示数据
        tableData: [],
        // 表格显示标题
        columns: [],
        // 表格是否加载中
        loading: false,
        // 分页
        pageData: {
          size: 10,
          page: 1,
          total: 1
        },
      },
      // 零碳出行
      table1: {
        // 表格展示数据
        tableData: [],
        // 表格显示标题
        columns: [],
        // 表格是否加载中
        loading: false,
        // 分页
        pageData: {
          size: 10,
          page: 1,
          total: 1
        },
      },
      // 弹出框设置
      dialog: {
        size: 720,
        visible: false,
        title: "新增",
      },
      // 是否显示操作按钮
      isShowView: true,
      // 用户信息
      userInfo: {},
      //
      type: 0,
      // 导出的弹出
      dialogVisible: false,
      // 校验
      rules: {
        startDate: [{ required: true, message: "选择开始日期" }],
        endDate: [{ required: true, message: "选择结束日期" }],
      },
      // 导出的日期表单
      form: {
        startDate: "",
        endDate: "",
      },
      pickerOptions3: {
        disabledDate: (time) => {
          const start = Date.parse(this.form.startDate);
          const end = Date.parse(this.form.endDate);
          if (this.form.endDate) {
            return time.getTime() > Date.now() || time.getTime() > end;
          } else {
            return time.getTime() > Date.now();
          }
        },
      },
      pickerOptions4: {
        disabledDate: (time) => {
          const start = Date.parse(this.form.startDate);
          const end = Date.parse(this.form.endDate);
          if (this.form.startDate) {
            return (
              time.getTime() < start - 1000 * 60 * 60 * 24
            );
          } else {
            // return time.getTime() > Date.now();
          }
        },
      },
      // 导出文件名
      fileName: "",
      excel: ''
    }
  },
  methods: {
    // 页面初始化
    init() {
      this.table.columns = columns
      this.table1.columns = columns1
      this.getList()
    },
    // 通过类型返回文字
    changeType(type) {
      if (type == 0) return '公共交通'
      else if (type == 1) return '自驾'
      else if (type == 2) return '飞机'
      else if (type == 3) return '高铁'
      else return ''
    },
    // 获取数据列表
    async getList() {
      let arrTab = [this.table, this.table1]
      let arrFun = [getActivity, getActivity]
      console.log(arrFun)
      let page = {
        current: arrTab[this.type].pageData.page,
        size: arrTab[this.type].pageData.size,
      };
      arrTab[this.type].loading = true
      this.search[this.type].type = this.type == 0 ? 1 : 0
      const res = await arrFun[this.type](this.search[this.type], page)
      if (res.data.code == 200) {
        arrTab[this.type].tableData = res.data.data.records
        arrTab[this.type].pageData.total = res.data.data.total
      }
      arrTab[this.type].loading = false
    },
    // 点击重置
    reset() {
      if (this.type == 0) {
        this.search[this.type] = {
          "meetingName": "",
          "transport": "",
          "type": ""
        }
      }
      else {
        this.search[this.type] = {
          "name": "",
          "phone": "",
          "transport": "",
          "type": ""
        }
      }
      this.getList()
    },
    changeTab(val) {
      this.type = val
      let arrTab = [this.table, this.table1]
      arrTab[val].tableData = []
      this.getList();
    },
    //
    sizeChange(val) {
      let arrTab = [this.table, this.table1]
      arrTab[this.type].pageData.size = val
      this.getList()
    },
    //
    currentChange(val) {
      let arrTab = [this.table, this.table1]
      arrTab[this.type].pageData.page = val
      this.getList()
    },
    // 关闭弹出框
    handleClose() {
      this.dialog.visible = false
    },
    //一级审核
    checkOne(id) {
      this.$confirm('是否审核通过?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const delArr = handleCheckOne
        delArr(id).then(res => {
          if (res.data.code == 200) {
            this.$message({
              type: 'success',
              message: '审核成功'
            });
            this.getList()
          }
          else {
            console.log(res)
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消审核'
        });
      });
    },
    //二级审核
    checkTwo(id) {
      this.$confirm('是否审核通过?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const delArr = handleCheckTwo
        delArr(id).then(res => {
          if (res.data.code == 200) {
            this.$message({
              type: 'info',
              message: '审核成功'
            });
            this.getList()
          }
          else {
            this.$message({
              type: 'info',
              message: res.message
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消审核'
        });
      });

    },
    // 导出
    isExport() {
      this.dialogVisible = true;
      this.fileName = ""
      this.form.startDate = ""
      this.form.endDate = ""
      
    },
    // 导出弹出窗关闭
    handleClose(done) {
      this.dialogVisible = false;
    },
    // 导出的提交
    async submitExport() {
      let bol = true;
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          bol = false;
          return false;
        }
      });
      if (bol) {
        if (this.type == 0) {
          this.fileName = "零碳活动"
          const res = await activityExport(this.form)
          console.log(res)
          console.log(res.data)
          if (res.data.type == "application/vnd.ms-excel") {
            console.log(res)
            console.log(res.data)
            this.excel = res.headers['content-disposition']
            this.$message.success("导出成功");
            this.downloadFile(res, this.fileName)
            this.excel = ""
            this.fileName = ""
            this.form.startDate = ""
            this.form.endDate = ""
            this.dialogVisible = false
          } else this.$message.error("筛选范围暂无数据");
        } else {
          this.fileName = "出行方式"
          const res = await travelExport(this.form)
          if (res.data.type == "application/vnd.ms-excel") {
            this.excel = res.headers['content-disposition']
            this.$message.success("导出成功");
            this.downloadFile(res, this.fileName)
            this.excel = ""
            this.fileName = ""
            this.form.startDate = ""
            this.form.endDate = ""
            this.dialogVisible = false
          } else this.$message.error("筛选范围暂无数据");
        }
      }




    },
    // 下载的方法
    downloadFile(response, fileName) {
      const headers = response.headers;
      const contentType = headers['content-type'];
      const blob = new Blob([response.data], { type: contentType });
      const temp = response.headers['content-disposition'];
      let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      let matches = filenameRegex.exec(temp);
      let fileType = '';
      if (matches != null && matches[1]) {
        fileType = matches['input'].substring(matches['input'].lastIndexOf('.'));
      }
      var downloadElement = document.createElement('a');
      var href = window.URL.createObjectURL(blob); //创建下载的链接
      downloadElement.href = href;
      downloadElement.download = fileName + fileType; //下载后文件名
      document.body.appendChild(downloadElement);
      downloadElement.click(); //点击下载
      document.body.removeChild(downloadElement); //下载完成移除元素
      window.URL.revokeObjectURL(href); //释放掉blob对象
    }



  },

  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.init()
  },
  components: {
    Breadcrumbs,
    Tables,
    Paginations,

  },
}
</script>
<style scoped>
.flex {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.home_main .main_table .table_btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.check-item {
  color: #fff;
  padding: 2px 2px;
  border-radius: 7px;
  background: #409eff;
  border-color: #409eff;
}

.uncheck-item {
  background: #c8c9cc;
  border-color: #c8c9cc;
  color: #fff;
  padding: 2px 2px;
  border-radius: 7px;
}
</style>
